var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-pm-5gc-dataQuery-tree"},[_c('ejs-treeview',{ref:"pmCounterTree",attrs:{"fields":_vm.fieldsOfPmCounterTree,"nodeSelected":_vm.nodeSelectedOfPmCounterTree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }